import { Badge } from '../../components/badge/Badge';

export const AuthorizationNotRealWarning = () => {
    return (
        <Badge color="warning" saturated={true}>
            WARNING: All authorizations shown here are simulated, and do not provide FAA approval to fly.
        </Badge>
    );
};
